import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// HACK!
eval('L.Browser.svg = true;');
